import { Badge } from 'src/design/atoms/Badge';
import { Box } from 'src/design/atoms/Box';
import { Grid } from 'src/design/atoms/Grid';
import React from 'react';
import { FiretrolScopes, IScope, IScopeSection } from 'src/data/scopes';

export interface IAllScopesProps {
  scopeList?: IScopeSection[];
  hideLabel?: boolean;
}

/** @registry Read-only grid of scope badges grouped by section, for display in scope-info dialogs. */
export const AllScopes: React.FC<IAllScopesProps> = ({
  scopeList = FiretrolScopes,
  hideLabel = false,
}) => {
  const renderTags = (items: IScope[]) => {
    return items.map((scope) => {
      return (
        <div key={scope.value}>
          <Badge mr="xs" mt="xs">
            {scope.label}
          </Badge>
        </div>
      );
    });
  };

  const renderCols = () => {
    return scopeList.map((s) => {
      return (
        <Grid.Col span={{ md: 4 }} key={s.title}>
          <h4 style={{ marginBottom: 0 }}>{s.title}</h4>
          {renderTags(s.scopes)}
        </Grid.Col>
      );
    });
  };

  return (
    <Box mb="md">
      {!hideLabel && <h3 style={{ marginBottom: 0 }}>Scopes</h3>}
      <Grid gutter={0}>{renderCols()}</Grid>
    </Box>
  );
};
